<template>
  <div id="publish-setting">
    <div class="ipub-h1 mar-b-24 line-h-40 relative">
      Publisher Setting
    </div>
    <site-tab class="mar-b-30"
              :menus="menus" />
    <router-view></router-view>
    <!-- 132456 -->
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
